import React from 'react';
import { FormControl, FormHelperText } from '@mui/material';
var CustomTextarea = function (_a) {
    var value = _a.value, onChange = _a.onChange, error = _a.error, placeholder = _a.placeholder, rows = _a.rows, fieldName = _a.fieldName, minrows = _a.minrows, maxLength = _a.maxLength, disabled = _a.disabled;
    return (React.createElement(FormControl, { error: Boolean(error), fullWidth: true, sx: { '& textarea': { borderColor: error ? '#d32f2f !important' : '' } } },
        React.createElement("textarea", { name: fieldName, value: value, onChange: onChange, placeholder: placeholder, rows: rows || minrows || 4, maxLength: maxLength, disabled: disabled, className: 'textarea', style: {
                width: '100%',
                border: '1px solid #c2c7d0',
                borderRadius: '4px',
                fontSize: '14px',
                color: '#696F88',
                padding: '8px 12px',
                resize: 'vertical',
                fontFamily: 'inherit',
                backgroundColor: disabled ? '#f3f4f6' : '#fff'
            } }),
        React.createElement(FormHelperText, { sx: { marginLeft: '0px', marginTop: '-5px', marginBottom: '5px' } }, error)));
};
export default CustomTextarea;
